import script from "./publicCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./publicCourse.vue?vue&type=script&setup=true&lang=js"

import "./publicCourse.vue?vue&type=style&index=0&id=049cebe8&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049cebe8"]])

export default __exports__